<template>
   <div class="">
    <router-link class="btn dealers_btn"  style="font-size: 15px" :to="{name:  'disconnected_pumps_history', query: {pumpId: data.pumpId, companyId: this.$route.query.companyId}}">
        {{$t('text.clickButtons.viewHistory')}}
    </router-link> 
      
  </div>
</template>

<script>
import configObject from "@/config";
import Jquery from "jquery";
let $ = Jquery;

export default {
  data() {
    return {
      data: {},
    };
  },
  mounted() {
  },
  methods: {
    
  },
};

</script>